module.exports = __webpack_public_path__ + "img/appIcon-menu--Integrations--active.beda579c.svg";